import React, { useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import ImageDialogTrigger from '../components/ImageDialogTrigger';
import ProjectBreadcrumbs from '../components/ProjectBreadcrumbs';
import circuitoEdicoes from '../data/circuitoEdicoes';
import resolvePublicAsset from '../utils/resolvePublicAsset';

function CircuitoPaulistaHipHop() {
  const location = useLocation();
  const navigate = useNavigate();
  const galeria = [
    {
      src: resolvePublicAsset('/images/araraquara_01.png'),
      alt: 'Registro do Acesso Popular em atividade'
    },
    {
      src: resolvePublicAsset('/images/araraquara_02.png'),
      alt: 'Parceiros do Instituto Acesso Popular'
    },
    {
      src: resolvePublicAsset('/images/araraquara_03.png'),
      alt: 'Material visual do projeto'
    }
  ];

  useEffect(() => {
    const scrollTargetId = location.state?.scrollTargetId;

    if (!scrollTargetId) {
      return;
    }

    const scrollToCard = () => {
      const targetCard = document.getElementById(scrollTargetId);

      if (!targetCard) {
        return;
      }

      targetCard.scrollIntoView({ behavior: 'auto', block: 'center' });
      navigate(location.pathname, { replace: true, state: null });
    };

    const animationFrameId = requestAnimationFrame(scrollToCard);

    return () => cancelAnimationFrame(animationFrameId);
  }, [location.pathname, location.state, navigate]);

  return (
    <div className="circuit-page">
      <section className="circuit-hero">
        <Container>
          <Row>
            <Col>
              <ProjectBreadcrumbs
                items={[
                  { label: 'Projetos', to: '/projetos' },
                  { label: 'Circuito Paulista de Hip Hop' }
                ]}
              />
            </Col>
          </Row>
          <Row className="align-items-center g-4">
            <Col lg={7}>
              <div className="circuit-hero-copy">
                <span className="circuit-kicker">Projeto Cultural Itinerante</span>
                <h1>Circuito Paulista de Hip Hop</h1>
                <div className="circuit-tags">
                  <span>Cultura urbana</span>
                  <span>Formação</span>
                  <span>Juventude</span>
                  <span>Interior paulista</span>
                </div>
              </div>
            </Col>
            <Col lg={5}>
              <div className="circuit-hero-visual">
                <div className="circuit-hero-card circuit-hero-card-main">
                  <img src={resolvePublicAsset('/images/logo_circuito_paulista_hiphop.png')} alt="Logo Circuito Paulista de Hip Hop" className="img-fluid" />
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="circuit-content-section">
        <Container>
          <Row className="g-4 align-items-start">
            <Col lg={8}>
              <div className="circuit-text-panel">
                <p>O Circuito Paulista de Hip Hop é um projeto cultural que já percorreu dezenas de cidades do interior do Estado de São Paulo com o objetivo de fortalecer e valorizar a cultura Hip Hop como expressão artística, social e transformadora. </p>
                <p>Realizada pelo Instituto Acesso Popular, em parceria com o mandato da deputada estadual Márcia Lia e com a articulação cultural de Meire Silva, segue fazendo parcerias com coletivos de todo interior, fortalecendo o movimento.</p>
                <p>Mais do que um evento artístico, o circuito se consolida como uma ação de valorização da cultura urbana, levando para as cidades muito rap, batalhas de rima, inúmeros DJs, shows de rap, breaking, intervenções de graffiti e oficinas formativas voltadas principalmente para jovens, sempre valorizando talentos das cidades por onde passa.</p>
                <p>
                  A proposta é democratizar o acesso à cultura, estimulando o protagonismo juvenil através da criação de uma grande rede cultural de coletivos e artistas locais, criando oportunidades de formação, visibilidade e intercâmbio entre diferentes cenas do Hip Hop.
                </p>
                <p>
                  O projeto também evidencia a importância de os recursos públicos destinados à cultura chegarem efetivamente às entidades e coletivos que atuam nos territórios, possibilitando que iniciativas culturais gratuitas alcancem a juventude e ampliem o acesso a experiências artísticas e formativas.
                </p>
                <p>
                  Ao ocupar espaços públicos, escolas e centros culturais com atividades abertas à população, o Circuito Paulista de Hip Hop contribui para o desenvolvimento das políticas culturais e para o fortalecimento da economia criativa, afirmando a cultura urbana como ferramenta de identidade, participação social e transformação por meio da arte.
                </p>
              </div>
            </Col>
            <Col lg={4}>
              <div className="circuit-side-stack">
                <div className="circuit-highlight-card">
                  <span className="circuit-highlight-label">Destaques</span>
                  <ul>
                    <li>Rap, breaking, graffiti e DJs em circulação pelo interior.</li>
                    <li>Oficinas e atividades formativas voltadas principalmente para jovens.</li>
                    <li>Parcerias com coletivos e artistas locais em cada edição.</li>
                  </ul>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="circuit-gallery-section">
        <Container>
          <div className="circuit-section-heading">
            <span>Atmosfera do Projeto</span>
          </div>
          <Row className="g-4">
            {galeria.map((imagem) => (
              <Col md={4} key={imagem.src}>
                <ImageDialogTrigger
                  src={imagem.src}
                  alt={imagem.alt}
                  triggerClassName="circuit-gallery-card"
                  imageClassName="img-fluid"
                />
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      <section className="circuit-editions-section" id="circuit-editions-section">
        <Container>
          <div className="circuit-section-heading">
            <span>Edições Realizadas</span>
            <h4 className='mt-3'>Cidades já contempladas nas edições mais recentes</h4>
          </div>
          {circuitoEdicoes.map((edicao) => (
            <section className="circuit-edition-showcase" id={`edicao-section-${edicao.slug}`} key={edicao.slug}>
              <div className="circuit-edition-showcase-header">
                <div className="circuit-edition-year">{edicao.ano}</div>
                <h5>{edicao.titulo}</h5>
                {/* <p>{edicao.resumo}</p> */}
              </div>
              <Row className="g-4">
                {edicao.cidades.map((cidade) => (
                  <Col xl={3} lg={3} md={6} key={`${edicao.slug}-${cidade.slug}`}>
                    <Link className="circuit-city-card-link" to={`/projetos/circuito-paulista-hip-hop/${edicao.slug}/${cidade.slug}`}>
                      <article className="circuit-city-card" id={`cidade-card-${edicao.slug}-${cidade.slug}`}>
                        <div className="circuit-city-card-image">
                          <img src={cidade.imagem} alt={cidade.alt} className="img-fluid" />
                        </div>
                        <div className="circuit-city-card-body">
                          {/* <span className="circuit-city-card-edition">{edicao.ano}</span> */}
                          <h6>{cidade.nome}</h6>
                          <p>{cidade.resumo}</p>
                          <span className="circuit-edition-cta">Ver mais</span>
                        </div>
                      </article>
                    </Link>
                  </Col>
                ))}
              </Row>
            </section>
          ))}
        </Container>
      </section>
    </div>
  );
}

export default CircuitoPaulistaHipHop;